import { Photo, PhotoType, Tree } from '../interfaces/tree';

export const getPhotosByType = (
  type: PhotoType,
  activeTree: Tree | undefined,
): Photo[] =>
  activeTree ? activeTree.tree_scanner_images.filter(p => p.type === type) : [];
